import { definePath } from '../../router/definePath';

export const ConfiguratorPaths = {
  configure: definePath('public', { de: '/paket-konfigurieren', en: '/configure-package' }),
} as const;
